import { ModalTitleContainer } from 'components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalTitleContainer'
import { Form, Formik } from 'formik'
import Styles from './Review.module.scss'
import { WrapperCard } from 'components/AddCampaignModal/WrapperCard'
import { ModalSubmitContainer } from 'components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalSubmitContainer'
import { Button } from 'blaze-ui/Button'
import { ReviewProps } from 'components/BatchCreateCampaignsModal/BatchCampaigns/Review/Types'
import { CampaignsField } from 'components/BatchCreateCampaignsModal/BatchCampaigns/Review/CampaignsField'
import { WeekDay } from 'types'

const DEFAULT_WEEKDAYS: Array<WeekDay> = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export const Review = ({ campaigns, onSubmit }: ReviewProps) => {
  return (
    <>
      <ModalTitleContainer>Review your campaign details</ModalTitleContainer>
      <Formik
        initialValues={{
          campaigns: campaigns.map((campaign) => {
            return {
              ...campaign,
              week_days: (campaign.week_days || []).length ? campaign.week_days : DEFAULT_WEEKDAYS,
            }
          }),
        }}
        onSubmit={(values) => onSubmit(values)}
      >
        {({ submitForm, isSubmitting }) => (
          <Form className={Styles.form}>
            <WrapperCard>
              <CampaignsField name="campaigns" />
            </WrapperCard>
            <ModalSubmitContainer>
              <Button size="lg" onPress={() => submitForm()} isDisabled={isSubmitting}>
                Create Campaigns
              </Button>
            </ModalSubmitContainer>
          </Form>
        )}
      </Formik>
    </>
  )
}
